import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
	paper: {
		padding: theme.spacing(2),
		width: "100%",
		backgroundColor: theme.palette.action.hover,
	},
	description: {
		fontWeight: 700,
	},
	labelRow: {
		paddingTop: theme.spacing(2.5),
	},
	value: {
		fontWeight: 400,
	},
	field: {
		width: "100%",
		backgroundColor: theme.palette.custom.creditRequest.fieldBackground,

		"& .MuiOutlinedInput-input, & .MuiSelect-select": {
			paddingTop: theme.spacing(1.675),
			paddingBottom: theme.spacing(1.675),
		},
		"& .MuiInputLabel-root:not(.MuiInputLabel-shrink)": {
			transform: "translate(14px, 13px) scale(1)",
		},
	},
	consignmentRow: {
		paddingTop: theme.spacing(1.5),
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
	},
	editButton: {
		color: theme.palette.text.primary,
		paddingRight: 0,
		textTransform: "none",
	},
	reasonRow: {
		paddingTop: theme.spacing(1.5),
	},
	copyButton: {
		height: 46,
	},
}));
